module.exports = __webpack_public_path__ + "img/kdLogoM_ZH.75bb42bc.png";